import { AfterViewInit, Component, ElementRef, ViewChild, input, effect, output, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { AppService } from '../../app.service';

@Component({ standalone: false,
  selector: 'app-countdown-timer',
  templateUrl: './countdown-timer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./countdown-timer.component.scss'],
})
export class CountdownTimerComponent implements AfterViewInit, OnDestroy {
    @ViewChild('days', { static: true }) days!: ElementRef;
    @ViewChild('hours', { static: true }) hours!: ElementRef;
    @ViewChild('minutes', { static: true }) minutes!: ElementRef;
    @ViewChild('seconds', { static: true }) seconds!: ElementRef;

    readonly compact = input<boolean>(false);
    readonly targetDateTime = input<number | undefined>(undefined);

    readonly timerEnded = output<any>();

    public targetTime?: number;
    private intervalId: any;
    private viewReady = false;

    constructor() {
        effect(() => {
            const target = this.targetDateTime();
            const now = Date.now();

            // Always tear down the previous interval when the input changes.
            this.stopInterval();

            if (target !== undefined && target >= now) {
                this.targetTime = target;
                if (this.viewReady) {
                    this.startInterval();
                }
            } else {
                this.targetTime = undefined;
            }
        });
    }

    ngAfterViewInit() {
        this.viewReady = true;
        if (this.targetTime !== undefined) {
            this.startInterval();
        }
    }

    ngOnDestroy() {
        this.stopInterval();
    }

    private startInterval() {
        this.stopInterval();
        this.tickTock();
        this.intervalId = setInterval(() => this.tickTock(), 1000);
    }

    private stopInterval() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = undefined;
        }
    }

    private tickTock() {
        let delta = (this.targetTime! - AppService.correctedDateNowUnix) / 1000;
        let days = 0, hours = 0, minutes = 0, seconds = 0;

        if (delta > 0) {
            days = Math.floor(delta / 86400);
            delta -= days * 86400;
            hours = Math.floor(delta / 3600) % 24;
            delta -= hours * 3600;
            minutes = Math.floor(delta / 60) % 60;
            delta -= minutes * 60;
            seconds = Math.floor(delta) % 60;
        } else {
            this.stopInterval();
            this.timerEnded.emit(undefined);
        }

        this.days.nativeElement.innerText = String(days);
        this.hours.nativeElement.innerText = String(hours);
        this.minutes.nativeElement.innerText = String(minutes);
        this.seconds.nativeElement.innerText = String(seconds);
    }
}